import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from 'src/app/user/services';
import { DatetimePickerComponent } from '../../datetime-picker/datetime-picker.component';
import { DateTimeService } from '../../datetime/datetime.service';
import { LoadingPanelService } from '../../loading-panel/loading-panel.service';
import { ChangeLogItem } from '../models/change-log-item';
import { EntityIdentifier } from '../models/change-log-request';
import { ChangeLogUser } from '../models/change-log-user';
import { ChangeLogService } from '../services/change-log.service';
import { RestrictedSearchCalloutComponent } from '../../restricted-search/restricted-search.component';
import { SvgIconComponent } from '../../icons/svg-icon.component';

@Component({
    selector: 'app-change-log-search',
    templateUrl: './change-log-search.component.html',
    styleUrls: ['./change-log-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [RestrictedSearchCalloutComponent, DatetimePickerComponent, SvgIconComponent]
})
export class ChangeLogSearchComponent implements OnInit {
  @ViewChild('datepickerFrom') private datepickerFrom: DatetimePickerComponent;
  @ViewChild('datepickerTo') private datepickerTo: DatetimePickerComponent;

  @Input() entities: EntityIdentifier[] = [];

  items: ChangeLogItem[] = [];
  notAllItems = false;
  users: ChangeLogUser[] = [];
  dateFrom: Date = null;
  dateTo: Date = null;
  maxRows = 5000;

  constructor(
    private userService: UserService,
    private changeLogService: ChangeLogService,
    private loadingPanelService: LoadingPanelService,
    private dateTimeService: DateTimeService) {
  }

  ngOnInit(): void {
    setTimeout(() => this.refresh());
  }

  async refresh(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Loading...');
      const newUsers = await this.userService.getUsers();

      this.users = newUsers.map(u => ({ id: u.UserId, name: u.DisplayName } as ChangeLogUser)).sort((a, b) => a.id - b.id);
      this.items = [];
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
    await this.search();
  }

  async search(): Promise<void> {
    try {
      this.loadingPanelService.showLoadingPanelDirect('Searching...');

      const newItems = await this.changeLogService.getChangeLogItems(this.entities, this.dateFrom, this.dateTo, this.maxRows + 1);

      this.notAllItems = newItems.length > this.maxRows;
      this.items = newItems.slice(0, this.maxRows);
    }
    finally {
      this.loadingPanelService.hideLoadingPanel();
    }
  }

  reset(): void {
    this.datepickerFrom.reset();
    this.datepickerTo.reset();
    this.dateFrom = this.dateTo = null;
    this.items = [];
    this.search();
  }

  setTimeSpan(type: string) {
    const now = new Date();
    const dateFrom = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const dateTo = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const period = this.dateTimeService.setTimeSpan(type, dateTo, dateFrom);

    this.datepickerFrom.setSelectedDate(period.start);
    this.dateFromChanged(period.start);

    this.datepickerTo.setSelectedDate(period.end);
    this.dateToChanged(period.end);
  }

  dateFromChanged(date: Date): void {
    this.dateFrom = date;
  }

  dateToChanged(date: Date): void {
    this.dateTo = date;
  }
}
